export enum ValuationMethod {
  QuantityInEaches = "QuantityInEaches",
  VendorCost = "VendorCost",
  ListWholesale = "ListWholesale",
}
